import {
  ApiAnnouncementPermissions,
  ApiNoticePermissions
} from "../constants/ApiPermissions";
import RulesetBase from "./rulesetBase";

/**
 * Ruleset for annoucement notices.
 *
 * @class
 * @extends {RulesetBase}
 */
class AnnouncementRuleset extends RulesetBase {
  defineRules = (userPermissions: string[]): void => {
    const {can} = this.abilityBuilder;
    let onlyRead = false;

    for (let permission of userPermissions) {
      if (
        permission.toUpperCase() ===
        ApiAnnouncementPermissions.readWrite.toUpperCase()
      ) {
        can("Create", "Announcement");
        can("Delete", "Announcement");
        can("Update", "Announcement");
        can("Read", "Announcement");
        onlyRead = false;
        break;
      } else if (
        permission.toUpperCase() === ApiNoticePermissions.read.toUpperCase()
      ) {
        onlyRead = true;
      }
    }
    if (onlyRead) {
      can("Read", "Announcement");
    }
  };
}

export default AnnouncementRuleset;
